import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { withRouter } from 'react-router-dom';

class GetQuotesButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.redirectToFormDemand = this.redirectToFormDemand.bind(this);
  }

  redirectToFormDemand() {
    if (this.props.auth && this.props.auth.isAuthenticated && this.props.productName) {
      this.props.onCloseModal && this.props.onCloseModal();
      this.props.history.push({
        pathname: '/user/post-demand',
        state: { contentDemandFromProduct: `Tôi muốn lấy báo giá cho sản phẩm ${this.props.productName}` }
      })
    } else {
      toastr.error('Lỗi!', 'Vui lòng đăng nhập gửi yêu cầu cho sản phẩm');
    }
  }

  render() {
    return (
      <button type="button" className="button-orange" onClick={this.redirectToFormDemand}>
        <span className="fa fa-phone"></span>Lấy báo giá
      </button>
    );
  }
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  };
};

export default withRouter(connect(bindStateToProps)(GetQuotesButton));



// WEBPACK FOOTER //
// ./components/partials/get-quotes-button/get-quotes-button.jsx